import script from "./payappointment.vue?vue&type=script&setup=true&lang=js"
export * from "./payappointment.vue?vue&type=script&setup=true&lang=js"

import "./payappointment.vue?vue&type=style&index=0&id=bdd91c0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdd91c0a"]])

export default __exports__